// Extensión del selector Prestige: opciones, referencias y cantidades de la variante activa.
(() => {
  if (window.MPVariants) return;
  const numeric = value => {
    const match = String(value).replace(/(\d)\.(?=\d{3}(?:\D|$))/g, '$1').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : Infinity;
  };
  const compare = (a, b) => numeric(a) - numeric(b) || String(a).localeCompare(String(b), 'es', { numeric: true });
  const nearest = (variants, values, changed) => {
    const exact = variants.find(v => v.optionIds.every((id, i) => id === values[i]));
    if (exact?.available) return exact;
    const candidates = variants.filter(v => v.available && v.optionIds[changed] === values[changed]);
    if (!candidates.length) return exact || variants.find(v => v.optionIds[changed] === values[changed]);
    const wanted = values.map((id, i) => variants.find(v => v.optionIds[i] === id)?.options[i]);
    const score = v => v.optionIds.reduce((sum, id, i) => {
      if (id === values[i]) return sum;
      const a = numeric(v.options[i]), b = numeric(wanted[i]);
      return sum + 100 + (Number.isFinite(a) && Number.isFinite(b) ? Math.abs(a - b) / Math.max(1, a, b) : 1);
    }, 0);
    return candidates.sort((a, b) => score(a) - score(b))[0];
  };
  const reference = variant => {
    if (!variant) return '';
    const parts = [];
    if (variant.sku) parts.push(`Ref. ${variant.sku}`);
    let measure = String(variant.measure || '').trim();
    const length = Number(variant.ml) > 0 ? new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(variant.ml * 1000) : '';
    if (measure && length) measure = measure.replace(/\s*mm$/i, '');
    if (measure || length) parts.push([measure, length].filter(Boolean).join(' × ') + (length || /^\d+(?:[.,]\d+)?$/.test(measure) ? ' mm' : ''));
    if (Number(variant.boxSize) > 1) parts.push(`Caja de ${variant.boxSize} tiras`);
    return parts.join(' · ');
  };
  const data = picker => JSON.parse(picker.querySelector('[data-mp-variants]').textContent);
  const markCombinations = (picker, variants) => {
    const selected = [...picker.querySelectorAll('input[data-option-position]:checked')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map(input => input.value);
    picker.querySelectorAll('input[data-option-position]').forEach(input => {
      const position = Number(input.dataset.optionPosition) - 1;
      const compatible = variants.filter(v => v.optionIds.every((id, i) => id === (i === position ? input.value : selected[i])));
      const label = input.nextElementSibling;
      if (label?.tagName !== 'LABEL') return; // Valor único: radio oculto sin botón.
      const unavailable = !compatible.some(v => v.available);
      label.classList.toggle('is-disabled', unavailable);
      input.dataset.mpUnavailable = String(unavailable);
      label.title = compatible.length ? (unavailable ? 'Agotado' : '') : 'No existe con las otras opciones. Seleccionar combinación más cercana.';
    });
  };
  const prepare = picker => {
    const variants = data(picker);
    picker.querySelectorAll('[data-mp-numeric] .variant-picker__option-values').forEach(list => {
      const inputs = [...list.querySelectorAll('input[data-option-position]')];
      const pairs = inputs.map(input => ({ input, label: input.nextElementSibling }));
      pairs.sort((a, b) => compare(a.label.textContent.trim(), b.label.textContent.trim()));
      pairs.forEach(({ input, label }) => list.append(input, label));
    });
    picker.querySelectorAll('input[type="radio"]').forEach(input => input.setAttribute('aria-checked', String(input.checked)));
    markCombinations(picker, variants);
    const selected = JSON.parse(picker.querySelector('[data-variant]').textContent);
    const info = picker.querySelector('[data-mp-variant-reference]');
    info.textContent = reference(variants.find(v => v.id === selected.id));
    info.hidden = !info.textContent;
  };
  const findInFragment = (fragment, selector) => fragment.querySelector(selector)
    || [...fragment.querySelectorAll('template')].map(template => findInFragment(template.content, selector)).find(Boolean);
  customElements.define('mp-variant-ready', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => { const picker = this.closest('[data-mp-variant-picker]'); if (picker?.isConnected) prepare(picker); }); }
  });
  const prepareAll = () => document.querySelectorAll('[data-mp-variant-picker]').forEach(prepare);
  // Prestige escucha en body: resolvemos la combinación antes de que envíe la petición.
  document.addEventListener('change', event => {
    const input = event.target;
    const picker = input.closest?.('[data-mp-variant-picker]');
    if (!picker || !input.matches('input[data-option-position]') || input.dataset.productUrl) return;
    picker.querySelectorAll('input[type="radio"]').forEach(el => el.setAttribute('aria-checked', String(el.checked)));
    const values = [...picker.querySelectorAll('input[data-option-position]:checked')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map(el => el.value);
    const chosen = nearest(data(picker), values, Number(input.dataset.optionPosition) - 1);
    if (!chosen || chosen.optionIds.every((id, i) => id === values[i])) return;
    event.stopImmediatePropagation();
    picker.selectCombination({ optionValues: chosen.optionIds, productChange: false });
  }, true);
  document.addEventListener('click', async event => {
    const row = event.target.closest?.('[data-mp-variant-picker] tbody tr');
    if (!row) return;
    const button = row.querySelector('[data-mp-select-variant]');
    if (!button || button.disabled) return;
    const picker = row.closest('[data-mp-variant-picker]');
    const chosen = data(picker).find(v => String(v.id) === button.dataset.mpSelectVariant);
    if (!chosen) return;
    const formId = picker.getAttribute('form-id');
    await picker.selectCombination({ optionValues: chosen.optionIds, productChange: false });
    const current = [...document.querySelectorAll('[data-mp-variant-picker]')].find(el => el.getAttribute('form-id') === formId);
    if (!current) return;
    current.querySelector('details').open = false;
    current.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    current.querySelector('input:checked')?.focus({ preventScroll: true });
  });
  // En el rerender parcial Prestige conserva calculadora y contenedor del formulario.
  document.addEventListener('product:rerender', event => {
    const fragment = event.detail.htmlFragment;
    const form = event.target;
    const current = form.closest('product-rerender') || [...document.querySelectorAll('product-rerender')].find(el => el.getAttribute('observe-form') === form.getAttribute('id'));
    const replacement = findInFragment(fragment, `product-rerender[id="${current?.id}"]`);
    if (!current || !replacement || event.detail.productChange || !current.hasAttribute('allow-partial-rerender') || !replacement.querySelector('[data-mp-variant-picker]')) return;
    current.querySelectorAll('product-form[data-mp-box-size], safe-sticky[data-mp-box-size]').forEach(node => {
      const next = replacement.querySelector(node.tagName.toLowerCase());
      if (next) Object.assign(node.dataset, next.dataset);
    });
    current.querySelectorAll('[data-block-type="flooring-calculator"]').forEach(block => {
      const next = replacement.querySelector(`[data-block-type="flooring-calculator"][data-block-id="${block.dataset.blockId}"]`);
      if (!next) return;
      const calculator = block.querySelector('flooring-calculator');
      const nextCalculator = next.querySelector('flooring-calculator');
      if (calculator?.updateVariant && nextCalculator) calculator.updateVariant(nextCalculator.dataset);
      else block.replaceWith(next); // Crea o desconecta la calculadora y sus listeners.
    });
    const info = current.querySelector('.product-info');
    const nextInfo = replacement.querySelector('.product-info');
    if (info && nextInfo) info.classList.toggle('product-info--has-calc', nextInfo.classList.contains('product-info--has-calc'));
    // Unidades y precios del presupuesto se renderizan en Liquid con la nueva variante.
    current.querySelectorAll('[data-block-type="quote-modal"]').forEach(block => {
      const next = replacement.querySelector(`[data-block-id="${block.dataset.blockId}"]`);
      if (next) block.replaceWith(next);
    });
    queueMicrotask(prepareAll);
  }, true);
  document.addEventListener('variant:change', event => {
    prepareAll();
    const form = event.target;
    const picker = [...document.querySelectorAll('[data-mp-variant-picker]')].find(el => el.getAttribute('form-id') === form.getAttribute('id'));
    if (!picker) return;
    const variant = data(picker).find(v => v.id === event.detail.variant?.id);
    if (!variant) return;
    [...form.elements].filter(el => el.name === 'quantity').forEach(input => {
      const size = Math.max(1, Number(variant.boxSize) || 1);
      input.value = input.type === 'hidden' ? size : Math.max(size, Math.ceil(Number(input.value) / size) * size);
    });
    [...form.elements].filter(el => /^properties\[(Cantidad|_cajas|_piezas|_m2_solicitados|_ml_solicitados|_merma_pct)\]$/.test(el.name)).forEach(el => el.remove());
  });
  document.addEventListener('shopify:section:load', prepareAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareAll, { once: true });
  else prepareAll();
  window.MPVariants = { numeric, compare, nearest, reference, prepare, markCombinations };
})();
